/*
  Pannello delle informative (spedizioni, rimborsi) nella scheda prodotto: il clic su un link con
  data-gf-policy apre il testo in un pannello laterale invece di cambiare pagina. Il testo è già nella
  pagina (<template id="gf-policy-…">, snippet gf-policy-panel). Senza template o senza <dialog>
  il link funziona come un link normale. Modulo: caricato una volta sola anche se lo snippet compare due volte.
*/
// nei moduli document.currentScript non c'è: l'etichetta del pulsante si legge dal tag dello snippet
const closeLabel = document.querySelector('script[src*="gf-policy-panel"]')?.dataset.closeLabel || 'Close';

let dialog;
let titleEl;
let bodyEl;
let opener;

function build() {
  dialog = document.createElement('dialog');
  dialog.className = 'gf-policy-panel';
  dialog.setAttribute('aria-labelledby', 'gf-policy-panel-title');

  const head = document.createElement('div');
  head.className = 'gf-policy-panel__head';

  titleEl = document.createElement('h2');
  titleEl.className = 'gf-policy-panel__title';
  titleEl.id = 'gf-policy-panel-title';

  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'gf-policy-panel__close';
  close.setAttribute('aria-label', closeLabel);
  close.innerHTML = '<span aria-hidden="true">×</span>';
  close.addEventListener('click', () => dialog.close());

  bodyEl = document.createElement('div');
  bodyEl.className = 'gf-policy-panel__body rte';
  // tabIndex 0: anche su Safari si torna sul testo con Tab per scorrerlo con le frecce
  bodyEl.tabIndex = 0;
  bodyEl.setAttribute('aria-labelledby', 'gf-policy-panel-title');
  bodyEl.setAttribute('role', 'region');

  head.append(titleEl, close);
  dialog.append(head, bodyEl);

  // clic sullo sfondo scuro (fuori dal pannello) chiude
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  });

  document.body.append(dialog);
}

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[data-gf-policy]') : null;
  if (!link || event.defaultPrevented) return;
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (typeof HTMLDialogElement === 'undefined') return;

  const template = document.getElementById(`gf-policy-${link.dataset.gfPolicy}`);
  if (!(template instanceof HTMLTemplateElement)) return;

  event.preventDefault();
  if (!dialog) build();

  titleEl.textContent = template.dataset.title || link.textContent.trim();
  bodyEl.replaceChildren(template.content.cloneNode(true));
  bodyEl.scrollTop = 0;
  opener = link;
  dialog.showModal();
  bodyEl.focus();
});
